import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Input, notification, Radio } from 'antd'
import styled from '@emotion/styled'
import { TextFieldInput } from '../../../components/common/TextField'
import { AgendarStore, IState, ParamsPilotarDto, isCpfCompleto } from './AgendarStore'
import AgendamentoCriado from './agendamento/AgendamentoCriado'
import DetalhesBoleto from './boletos/DetalhesBoleto'
import TurmasDisponiveis from './turmas/TurmasDisponiveis'
import NovoAgendamento from './agendamento/NovoAgendamento'
import BoletoVencido from './boletos/BoletoVencido'
import { Show } from '../../../components/common/Show'
import { isValid as isCpfValid, format as formatCpf } from '@fnando/cpf'
import { isValid as isCnpjValid, format as formatCnpj } from '@fnando/cnpj'
import { StatusAgendamento } from '../../../components/models/Models'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { parseISO } from 'date-fns'
import { gerarCpf } from '../../../components/common/Utils'
import Menu from '../../../components/menu/Menu'
import { TimeLine } from '../../../components/timeline/TimeLine'
import { ReactComponent as IdCard } from '../../../assets/icons/id-card.svg'
import { DatePicker } from '../../../components/datepicker/DatePicker'
import { TailSpin } from 'react-loader-spinner'

export const AgendarContainer = () => {
  const { Layout, CardAluno, CardModule, Flex, Title, SubTitle, WrapperInputs, ...props } =
    AgendarContainer
  const paramsPilotar = useParams<ParamsPilotarDto>()
  const [hiddenMenu, setHiddenMenu] = useState(false)

  const init = useCallback((dispatch: any) => {
    getParamsPilotar(dispatch, paramsPilotar)
  }, [])

  return (
    <AgendarStore.Provider init={init}>
      <Layout>
        <ShowStore when={isShowLoaderPilotar}>
          <LoaderPilotar />
        </ShowStore>
        <ShowStore when={showContainerDefault}>
          <Menu setHiddenMenu={setHiddenMenu} hiddenMenu={hiddenMenu} pageActive="agendar" />
          <CardAluno>
            <div className="container-titles">
              <Title>Seja bem vindo ao agendamento do Curso Teórico</Title>
              <SubTitle>Abaixo mostraremos seu status quanto ao agendamento do curso!</SubTitle>
            </div>
            <TimeLineContainer />
            <strong>Dados do aluno </strong>
            <WrapperInputs>
              <Cpf />
              <Nome />
            </WrapperInputs>
            <Flex>
              <Telefone />
              <Renach />
              <DataRenach />
            </Flex>
            <ContainerModules>
              <ShowIfStatus requiredStatus="NOVO">
                <CardModule data-cy="titulo-painel">
                  <NovoAgendamento />
                </CardModule>
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="PENDENTE">
                <CardModule data-cy="titulo-painel">
                  <DetalhesBoleto />
                </CardModule>
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="PAGO">
                <CardModule data-cy="titulo-painel">
                  <TurmasDisponiveis />
                </CardModule>
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="AGENDADO">
                <CardModule data-cy="titulo-painel">
                  <AgendamentoCriado />
                </CardModule>
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="VENCIDO">
                <CardModule data-cy="titulo-painel">
                  <BoletoVencido />
                </CardModule>
              </ShowIfStatus>
            </ContainerModules>
          </CardAluno>
        </ShowStore>
        <ShowStore when={showContainerHasParams}>
          <CardAluno layoutPilotar>
            <ContainerModules>
              <ShowIfStatus requiredStatus="NOVO">
                <CardModule data-cy="titulo-painel"></CardModule>
                <NovoAgendamento />
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="PENDENTE">
                <CardModule data-cy="titulo-painel">
                  <DetalhesBoleto />
                </CardModule>
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="PAGO">
                <CardModule data-cy="titulo-painel">
                  <TurmasDisponiveis />
                </CardModule>
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="AGENDADO">
                <CardModule data-cy="titulo-painel">
                  <AgendamentoCriado />
                </CardModule>
              </ShowIfStatus>

              <ShowIfStatus requiredStatus="VENCIDO">
                <CardModule data-cy="titulo-painel">
                  <BoletoVencido />
                </CardModule>
              </ShowIfStatus>
            </ContainerModules>
          </CardAluno>
        </ShowStore>
      </Layout>
    </AgendarStore.Provider>
  )
}
AgendarContainer.Layout = styled.div`
  background: #c0c0c0c0;
  min-height: 100vh;
  display: flex;
`
const showContainerDefault = (state: IState) => {
  const noParams = state.statusParamsPilotar === 'NO_PARAMS'
  const paramsEmpty = !state.statusParamsPilotar
  const loadingPilotar = state.loadingDadosAlunoPilotar
  return !state.paramsPilotar && !loadingPilotar && (noParams || paramsEmpty)
}
const showContainerHasParams = (state: IState) => {
  return state.statusParamsPilotar === 'HAS_PARAMS'
}
const showContainerInvalidParams = (state: IState) => {
  return state.statusParamsPilotar === 'INVALID_PARAMS'
}

AgendarContainer.WrapperInputs = styled.div`
  display: flex;
  gap: 10px;
  .cpf {
    flex: 1;
    width: 100%;
  }
  .nome {
    flex: 2;
    width: 100%;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
AgendarContainer.Title = styled.div`
  font-weight: 650;
  line-height: 1.5;
  font-size: 30px;
  color: #fbba3e;
  text-align: center;
`
AgendarContainer.SubTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: #7f7f7d;
  text-align: center;
  margin: 10px 0 30px 0;
`
AgendarContainer.CardAluno = styled.div<{ layoutPilotar?: boolean }>`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  ${(props) =>
    !props.layoutPilotar
      ? 'border-radius: 15px; margin: 15px 20px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);'
      : ''}
`
AgendarContainer.Flex = styled.div<any>`
  display: flex;
  gap: 10px;
  .renach {
    flex: 2;
  }
  .dataRenach {
    flex: 1;
  }
  .telefone {
    flex: 1;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
AgendarContainer.MenuMobile = styled(Menu)`
  display: none;
`
AgendarContainer.CardModule = styled.div``

const ContainerModules = ({ children }: { children: any }) => {
  const { Layout } = ContainerModules
  return <Layout>{children}</Layout>
}
ContainerModules.Layout = styled.div`
  display: grid;
  gap: 10px;
`

const Cpf = () => {
  const { InputContainer } = Cpf
  const {
    status,
    agendamento: { cpf, isCnhSocial, tipoAgendamento },
    loadingDadosAluno,
  } = AgendarStore.useState()
  const isReposicao = tipoAgendamento === 'REPOSICAO'
  const showSufix = isReposicao || isCnhSocial
  const dispatch = AgendarStore.useDispatch()
  const params = useParams<{ cpf: string }>()

  useEffect(() => {
    const localCpf = params?.cpf?.replace(/[_.-]/g, '')
    if (!localCpf) return
    if (localCpf.length !== 11 || !isCpfValid(localCpf)) return
    dispatch(AgendarStore.actions.changeCpf(params?.cpf))
  }, [])

  useEffect(() => {
    const localCpf = cpf.replace(/[_.-]/g, '')

    if (localCpf.length !== 11) {
      if (status !== 'HIDDEN' || isCnhSocial) dispatch(AgendarStore.actions.clearAgendamento())
      return
    }

    if (!isCpfValid(localCpf)) return notification.error({ message: 'CPF Inválido!' })
    dispatch(AgendarStore.actions.changeTimeLineStatusDadosAluno())
    dispatch(AgendarStore.thunks.searchAgendamento(cpf))
  }, [cpf])

  const handleChange = (e: any) => {
    dispatch(AgendarStore.actions.changeCpf(e.target.value))
  }

  const handlePaste = (e: any) => {
    dispatch(AgendarStore.actions.clearAgendamento())
    handleChange(e)
  }

  const handleKeyPress = (e: any) => {
    if (process.env.NODE_ENV === 'production') return
    if (e.ctrlKey && e.shiftKey && e.key === '?')
      dispatch(AgendarStore.actions.changeCpf(gerarCpf()))
  }

  return (
    <InputContainer className="cpf">
      <TextFieldInput
        mask="cpf"
        value={cpf}
        onChange={handleChange}
        onPaste={handlePaste}
        onKeyDown={handleKeyPress}
        autoFocus
        size="large"
        data-cy="cpf"
        suffix={showSufix ? <TagInfo /> : null}
        isLoading={loadingDadosAluno}
        disabled={loadingDadosAluno}
        label="CPF Aluno"
      />
    </InputContainer>
  )
}

Cpf.InputContainer = styled.div`
  width: 49%;
  .ant-input-affix-wrapper-lg {
    padding: 3.4px;
  }
`

const TagInfo = () => {
  const {
    agendamento: { tipoAgendamento, isCnhSocial },
  } = AgendarStore.useState()
  const isReposicao = tipoAgendamento === 'REPOSICAO'
  const { Layout, ContainerInfo } = TagInfo

  if (!isCnhSocial && !isReposicao) return null
  return (
    <Layout>
      <Show condition={isCnhSocial}>
        <ContainerInfo>
          <IdCard />
          <span>CNH Social</span>
        </ContainerInfo>
      </Show>
      <Show condition={isReposicao}>
        <ContainerInfo>
          <IdCard />
          <span>Reposição</span>
        </ContainerInfo>
      </Show>
    </Layout>
  )
}

TagInfo.Layout = styled.div`
  display: flex;
  gap: 4px;

  svg {
    margin-right: 4px;
  }
`

TagInfo.ContainerInfo = styled.div`
  display: flex;
  background: #fff4cf;
  font-size: 12px;
  border: 2px solid #f9da6e;
  border-radius: 6px;
  padding: 4px;

  span {
    align-self: end;
  }
`

const Nome = () => {
  const {
    status,
    agendamento: { nome, isAgendamentoVsoft },
  } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()
  const { InputContainer } = Nome

  return (
    <InputContainer className="nome">
      <TextFieldInput
        size="large"
        value={nome}
        onChange={(e) => dispatch(AgendarStore.actions.changeNome(e.target.value))}
        label="Nome do Aluno"
        disabled={
          !AgendarStore.useSelector(isCpfCompleto) || status !== 'NOVO' || isAgendamentoVsoft
        }
        data-cy="nome"
      />
    </InputContainer>
  )
}

Nome.InputContainer = styled.div`
  width: 49%;
`

const Renach = () => {
  const {
    status,
    agendamento: { renach, isAgendamentoVsoft },
  } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()

  return (
    <div className="renach">
      <TextFieldInput
        value={renach}
        mask="renach"
        onChange={(e) => dispatch(AgendarStore.actions.changeRenach(e.target.value))}
        size="large"
        disabled={
          !AgendarStore.useSelector(isCpfCompleto) || status !== 'NOVO' || isAgendamentoVsoft
        }
        data-cy="renach"
        label="Renach Aluno"
        autoFocus
      />
    </div>
  )
}

const DataRenach = () => {
  const {
    agendamento: { dataRenach },
  } = AgendarStore.useState()

  const date = dataRenach ? (moment(parseISO(dataRenach)) as any) : undefined

  return (
    <div className="dataRenach">
      <DatePicker label="Data Renach" disabled value={date} />
    </div>
  )
}

const TipoCurso = () => {
  const { Layout } = TipoCurso

  const dispatch = AgendarStore.useDispatch()
  const {
    status,
    agendamento: { cpf, tipoCurso },
  } = AgendarStore.useState()

  const cpfCompleto = cpf.replace(/[_.-]/g, '').length === 11

  const handleChange = (e: any) => {
    dispatch(AgendarStore.actions.changeTipoCurso(e.target.value))
  }

  return (
    <Layout className="tipo">
      <Radio.Group
        onChange={handleChange}
        value={tipoCurso}
        disabled={!cpfCompleto || status !== 'NOVO'}
      >
        <Radio value="PRIMEIRA_VIA">Primeira Via</Radio>
        <Radio value="RENOVACAO">Renovação</Radio>
      </Radio.Group>
    </Layout>
  )
}
TipoCurso.Layout = styled.div`
  justify-self: left;
  text-align: right;
`

const Telefone = () => {
  const {
    status,
    agendamento: { telefone },
  } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()

  const isTelefoneInvalid = useMemo(() => {
    if (!telefone) return ''
    const telefoneSanitize = telefone.replace(/[^0-9]/g, '').trim()
    if (telefoneSanitize.split('').every((item) => item === telefoneSanitize[0]))
      return 'Telefone inválido'
    const regex = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
    return !regex.test(telefone) ? 'Telefone inválido' : ''
  }, [telefone])

  useEffect(() => {
    dispatch(AgendarStore.actions.changeIsTelefoneValid(!isTelefoneInvalid))
  }, [isTelefoneInvalid])

  return (
    <div className="telefone">
      <TextFieldInput
        mask="telefone"
        value={telefone}
        onChange={(e: any) => dispatch(AgendarStore.actions.changeTelefone(e.target.value))}
        label="Telefone Aluno"
        size="large"
        disabled={!AgendarStore.useSelector(isCpfCompleto) || status !== 'NOVO'}
        data-cy="telefone"
        error={isTelefoneInvalid}
      />
    </div>
  )
}

const Email = () => {
  const {
    status,
    agendamento: { cpf, email },
  } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()

  return (
    <div className="email">
      <label>
        E-mail
        <Input
          type="email"
          value={email}
          // onChange={e => dispatch(StoreAgendar.actions.changeEmail(e.target.value))}
          placeholder="Informe o E-mail do aluno"
          size="large"
          name="email"
          disabled={!AgendarStore.useSelector(isCpfCompleto) || status !== 'NOVO'}
          data-cy="email"
        />
      </label>
    </div>
  )
}

const TimeLineContainer = () => {
  const { timeLine } = AgendarStore.useState()

  const { Layout } = TimeLineContainer
  return (
    <Layout>
      <TimeLine status={timeLine} />
    </Layout>
  )
}
TimeLineContainer.Layout = styled.div`
  margin-bottom: 50px;
`

const isShowLoaderPilotar = (state: IState) => {
  return (
    !showContainerDefault(state) &&
    (!!state.loadingDadosAlunoPilotar || !!state.loadingCfcsOrigem || !!state.loadingTurmas)
  )
}
const LoaderPilotar = () => {
  const { Container, Layout } = LoaderPilotar

  return (
    <Container>
      <Layout>
        <TailSpin color="#FBBA3E" height={120} width={120} visible={true} />
      </Layout>
    </Container>
  )
}
LoaderPilotar.Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: grid;
  place-items: center;
  z-index: 9999;
`
LoaderPilotar.Layout = styled.div`
  margin: 0 auto;
  max-width: 1100px;
  display: flex;
`

const ShowIfStatus = ({
  children,
  requiredStatus,
}: {
  children: any
  requiredStatus: StatusAgendamento
}) => {
  const { status } = AgendarStore.useState()
  if (requiredStatus.includes(status)) return children
  return null
}

const ShowStore = ({ children, when }: { children: any; when: (state: IState) => boolean }) => {
  const state = AgendarStore.useState()
  return when(state) ? children : null
}

function getParamsPilotar(dispatch: any, paramsPilotar: ParamsPilotarDto) {
  const { cpfPilotar, cnpjCfcPilotar, telefonePilotar } = paramsPilotar
  const hasPilotarParams = !!cpfPilotar && !!cnpjCfcPilotar && !!telefonePilotar
  if (!!hasPilotarParams) {
    try {
      if (!validateParamsPilotar(paramsPilotar)) {
        notification.error({ message: 'Os parametros estão inválidos.' })
        dispatch(AgendarStore.actions.setSearchParams({ params: null, status: 'INVALID_PARAMS' }))
        return
      }
      const { telefone, cpf, cnpj } = sanitizeCpfCnpjTelefone(paramsPilotar)
      const telefoneFomated = getFormatedTelefone(telefone)
      const cpfFormated = getFormatedCpf(cpf)
      const cnpjCfcPilotarFormated = getFormatedCnpj(cnpj)
      dispatch(
        AgendarStore.thunks.searchAgendamentoPilotar({
          ...paramsPilotar,
          telefonePilotar: telefoneFomated,
          cpfPilotar: cpfFormated,
          cnpjCfcPilotar: cnpjCfcPilotarFormated,
          renach: paramsPilotar.renach,
          tipoProcesso: paramsPilotar.tipoProcesso,
        })
      )
    } catch (error) {
      notification.error({ message: 'Não foi possível obter os dados do Pilotar' })
      dispatch(AgendarStore.actions.setSearchParams({ params: null, status: 'INVALID_PARAMS' }))
      return
    }
  }
  dispatch(AgendarStore.actions.setSearchParams({ params: null, status: 'NO_PARAMS' }))
}

function validateParamsPilotar(params: ParamsPilotarDto) {
  const paramsList = Object.keys(params)
  const hasParams = ['cpfPilotar', 'telefonePilotar', 'cnpjCfcPilotar'].every((item) => {
    return paramsList.includes(item) && params[item as keyof ParamsPilotarDto]
  })
  if (!hasParams) return false
  const { cpf, telefone, cnpj } = sanitizeCpfCnpjTelefone(params)
  if (cpf.length !== 11) return false
  if (!isCpfValid(cpf)) return false
  if (!isCnpjValid(cnpj)) return false
  if (telefone.length < 10) return false
  if (telefone.length > 11) return false
  return true
}

function sanitizeCpfCnpjTelefone(paramsParsed: ParamsPilotarDto) {
  const cpf = paramsParsed.cpfPilotar.replace(/[^0-9]/g, '')
  const telefone = paramsParsed.telefonePilotar.replace(/[^0-9]/g, '')
  const cnpj = paramsParsed.cnpjCfcPilotar.replace(/[^0-9]/g, '')
  return { cpf, telefone, cnpj }
}

function getFormatedTelefone(numero: string) {
  const numeroLimpo = numero.replace(/\D/g, '')
  const numeroFormatado = numeroLimpo.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3')
  return numeroFormatado
}
function getFormatedCpf(cpf: string) {
  return formatCpf(cpf)
}
function getFormatedCnpj(cnpj: string) {
  return formatCnpj(cnpj)
}
